import Vuex from 'vuex';
import EventEmitter from 'eventemitter3';
import Cookie from 'js-cookie';
import qs from 'qs';
import { httpClient } from '../../service/http';
import router from '../../router';
import { defaults, isNaN, uniqBy } from 'lodash-es';
import {
  hasAccount,
  isSubscribe,
  userHasState,
} from '../../service/activity/RuleSet';
import { auth } from '../../service/auth';
import { sdk } from '../../service/platform';
import { IS_MQQ, IS_ZXG } from '../../service/platform/environment';

function saveUserInfo(data: any) {
  if (data.headimgurl || data.nickname) {
    return httpClient.get('usersetting.cgi', {
      params: data,
      silent: true,
    } as any);
  }
}

function getQQUserDetail(qq: string, skey: string) {
  return new Promise((resolve) => {
    const win = window as any;
    const prevFn = win.loginAll;
    win.loginAll = (data: any) => {
      prevFn && prevFn(data);
      resolve({
        headimgurl: data.Face,
        nickname: data.nick,
      });
    };
    const url = [
      '//qfwd.qq.com/',
      qs.stringify({
        uin: qq.trim(),
        skey,
        func: 'loginAll',
        refresh: 0,
      }),
    ].join('?');
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = url;
    document.body.appendChild(script);
  }).then(saveUserInfo);
}

function jumpToZxgApp() {
  const url =
    'https://wzq.tenpay.com/activity/page/181124/?stat_data=Ocs11p00gf173';
  location.href =
    'http://finance.qq.com/products/jumpPage.html?number=2022&url=' +
    encodeURIComponent(url);
}

function parseEnum(value: any) {
  const result = parseInt(value);
  if (isNaN(result)) return undefined;
  return result;
}
export enum Progress {
  INITIAL = 0,
  HAS_WISH = 1,
  HAS_REDBAG = 2,
  GOT_REDBAG = 3,
  INVITING = 4,
  INVITE_END = 5,
  GOT_INVITE_REDBAG = 6,
}

export enum RewardType {
  MONEY = 1,
  IPHONE = 2,
  VIP = 6,
}

export enum SupportState {
  ENDED = 1,
  INITIAL = 2,
  SUPPORTED = 3,
}

interface State {
  subscribe: boolean;
  qrcode: any;
  shareEventEmitter: EventEmitter;
  zxgInstalled: boolean;
  static: {
    headimgurl: string;
    nickname: string;
    beginTime: Date;
    endTime: Date;
    inviteBeginTime: Date;
    inviteEndTime: Date;
    userEndTime: Date;
    nextRound: number;
    currentRound: number;
    url: string;
    sign: string;
  };
  reward: {
    rewardType: number;
    rewardValue: number;
  };
  support: {
    friends: number;
    rank: number;
    values: number;
    helpList: any[];
    userValue: number;
    maxValue: number;
  };
  fruitLimit: number;
  wish: string;
  progress: Progress;
  userSupportState: SupportState;
  rewardList: any[];
}
export const store = new Vuex.Store<State>({
  state: {
    shareEventEmitter: null,
    zxgInstalled: false,
    qrcode: {
      default: 'http://weixin.qq.com/q/02K9iWVNPG9FU10000g03C',
      friend: 'http://weixin.qq.com/q/02ZDk7VKPG9FU10000g03V',
      reward: 'https://w.url.cn/s/AXeP5dC',
      reward_zxg: 'https://w.url.cn/s/A0WgoAL',
    },
    subscribe: true,
    static: {
      headimgurl: null,
      nickname: null,
      beginTime: null,
      endTime: null,
      inviteBeginTime: null,
      inviteEndTime: null,
      nextRound: null,
      currentRound: null,
      url: null,
      sign: null,
      userEndTime: null,
    },
    reward: {
      rewardType: null,
      rewardValue: 0,
    },
    support: {
      friends: null,
      rank: null,
      values: null,
      helpList: [],
      userValue: null,
      maxValue: null,
    },
    fruitLimit: null,
    wish: null,
    progress: null,
    userSupportState: null,
    rewardList: null,
  },
  actions: {
    async updateShareEventEmitter({ state }, emitter) {
      state.shareEventEmitter = emitter;
    },
    // jumpToZxgApp,
    async updateSubscribeState({ state }, val: boolean) {
      state.subscribe = val;
    },
    async updateProgress({ commit, state }, other = {}) {
      state.zxgInstalled = await sdk.checkAppInstalled(
        'com.tencent.portfolio',
        'qqstock://qqstockweixincallback',
      );

      const { uid, sign } = other;
      const { data } = await cgi.getProgress(uid, sign);
      const authInfo = auth.getLoginInfo();

      // 后台无法获取到用户信息
      if (!data.headimgurl && !data.nickname) {
        if (/QQ/.test(authInfo.wzq_qluin) && IS_MQQ) {
          getQQUserDetail(Cookie.get('qluin'), Cookie.get('skey'));
        } else if (IS_ZXG) {
          window.StockJSBridge.invoke('login', {}, (data) => {
            saveUserInfo({
              headimgurl: data.headUrl,
              nickname: data.nickName,
            });
          });
        }
      }

      state.subscribe = await isSubscribe();
      state.static = defaults(
        {
          headimgurl: data.headimgurl,
          nickname: data.nickname,
          beginTime: new Date(data.begin_time * 1000),
          endTime: new Date(data.end_time * 1000),
          inviteBeginTime: new Date(data.invite_begin * 1000),
          inviteEndTime: new Date(data.invite_end * 1000),
          userEndTime: new Date(data.user_end * 1000),
          nextRound: parseEnum(data.next_round),
          currentRound: parseEnum(data.round),
          url: data.url,
          sign: data.sign,
        },
        state.static,
      );
      state.support = defaults(
        {
          userValue: parseInt(data.help_value),
        },
        state.support,
      );
      state.fruitLimit = parseInt(data.fruit_limit);
      state.progress = parseEnum(data.progress);
      state.userSupportState = parseEnum(data.user_state);
      state.wish = data.wish || state.wish;

      state.reward = defaults(
        {
          rewardType: parseEnum(data.reward_type),
          rewardValue: parseEnum(data.reward_value),
        },
        state.reward,
      );

      return data;
    },
    async fetchRewardList({ state }) {
      const { data } = await cgi.getRewardList();
      state.rewardList = data.reward_list;
    },
    async submitWish({ state }, wish) {
      const { data } = await cgi.submitWish(wish);
      state.wish = wish;
      state.fruitLimit = parseInt(data.fruit_limit);
      state.progress = Progress.HAS_WISH;
      router.replace('/game');
    },
    async updateGameResult({ state }, { count }) {
      const { data } = await cgi.updateGameResult(count);
      state.progress = Progress.HAS_REDBAG;
      return data;
    },
    async getFriendSupportDetail(
      { state },
      { timestamp, page, pageSize, pagination, uid, sign },
    ) {
      const { data } = await cgi.getFriendSupportDetail(
        timestamp,
        uid,
        sign,
        page,
        pageSize,
        pagination,
      );

      state.support = defaults(
        {
          friends: parseEnum(data.friends),
          rank: parseEnum(data.rank),
          values: parseEnum(data.values),
          helpList: uniqBy(
            state.support.helpList.concat(data.help_list || []),
            'uid',
          ),
          maxValue: parseEnum(data.max_value),
        },
        state.support,
      );
    },
    async inviteFriend({ state }) {
      const { data } = await cgi.inviteFriend();
      state.progress = Progress.INVITING;
      state.static = defaults(
        {
          headimgurl: data.headimgurl,
          nickname: data.nickname,
          inviteEndTime: new Date(data.invite_end * 1000),
          url: data.url,
          sign: data.sign,
        },
        state.static,
      );
      return data;
    },
    async endCurrentRound({ state }) {
      const { data } = await cgi.endCurrentRound();
      state.progress = Progress.INVITE_END;
      state.static = defaults(
        {
          headimgurl: data.headimgurl,
          nickname: data.nickname,
        },
        state.static,
      );
      return data;
    },
    async getWishReward({ state }) {
      const { data } = await cgi.getWishReward();
      state.progress = Progress.GOT_REDBAG;
      state.reward = defaults(
        {
          rewardType: parseEnum(data.reward_type),
          rewardValue: parseEnum(data.reward_value),
        },
        state.reward,
      );
      return data;
    },
    async getShareReward({ state }) {
      const { data } = await cgi.getShareReward();
      state.progress = Progress.GOT_INVITE_REDBAG;
      state.reward = defaults(
        {
          rewardType: parseEnum(data.reward_type),
          rewardValue: parseEnum(data.reward_value),
        },
        state.reward,
      );
      return data;
    },
    async supportFriend({ state }, { uid, sign, wish }) {
      const { data } = await cgi.supportFriend(uid, sign, wish);
      state.userSupportState = SupportState.SUPPORTED;
      state.support = defaults(
        {
          userValue: parseInt(data.help_wealth),
        },
        state.support,
      );
      return data;
    },
  },
});

export const cgi = {
  getProgress(uid?: string, sign?: string, ignoreAllError?: boolean) {
    const params = {
      action: 1,
    };
    const info = auth.getLoginInfo();
    if (info.wzq_qluin !== uid) {
      Object.assign(params, {
        uid,
        sign,
      });
    }
    return httpClient.get('activity/wish_activity.fcgi', {
      params,
      ignoreAllError,
    } as any);
  },
  getRewardList() {
    return httpClient.get('activity/wish_activity.fcgi', {
      silent: true,
      params: {
        action: 11,
      },
    } as any);
  },
  submitWish(wish: string) {
    return httpClient.get('activity/wish_activity.fcgi', {
      params: {
        wish,
        action: 2,
      },
    });
  },
  updateGameResult(count: number) {
    return httpClient.get('activity/wish_activity.fcgi', {
      params: {
        fruits: count,
        action: 3,
      },
    } as any);
  },
  getWishReward() {
    return httpClient.get('activity/wish_activity.fcgi', {
      params: {
        action: 4,
      },
    });
  },
  inviteFriend() {
    return httpClient.get('activity/wish_activity.fcgi', {
      params: {
        action: 5,
      },
    });
  },
  getFriendSupportDetail(
    timestamp: number,
    uid: any,
    sign: any,
    page = 1,
    pageSize = 5,
    pagination = true,
  ) {
    const info = auth.getLoginInfo();
    const params = {
      action: 7,
      get_total: pagination ? 1 : 0,
      end_time: timestamp,
      page_num: page,
      page_size: pageSize,
    };
    if (info.wzq_qluin !== uid) {
      Object.assign(params, {
        uid,
        sign,
      });
    }
    return httpClient.get('activity/wish_activity.fcgi', {
      params,
      silent: true,
    } as any);
  },
  endCurrentRound() {
    return httpClient.get('activity/wish_activity.fcgi', {
      params: {
        action: 8,
      },
    } as any);
  },
  getShareReward() {
    return httpClient.get('activity/wish_activity.fcgi', {
      params: {
        action: 9,
      },
    } as any);
  },
  supportFriend(uid: string, sign: string, wish: string) {
    return httpClient.get('activity/wish_activity.fcgi', {
      params: {
        action: 10,
        uid,
        sign,
        wish,
      },
    });
  },
};
